import store from 'store';
export var THEMES;
(function (THEMES) {
    THEMES["dark"] = "dark";
    THEMES["light"] = "light";
    THEMES["michelinLightBC"] = "michelinLightBC";
})(THEMES || (THEMES = {}));
/**
 * @deprecated discontinue usage; will be removed in next major version update
 */
export var ThemesList = [
    { value: THEMES.dark, label: 'Dark' },
    { value: THEMES.light, label: 'Light' },
];
export var ALLOWED_THEMES = [THEMES.dark, THEMES.light];
export var themeKey = "theme_".concat(window.location.origin);
export var getPossibleTheme = function (storeApi, storeThemeKey, allowedThemes, defaultTheme) {
    if (storeApi === void 0) { storeApi = store; }
    if (storeThemeKey === void 0) { storeThemeKey = themeKey; }
    if (allowedThemes === void 0) { allowedThemes = ALLOWED_THEMES; }
    if (defaultTheme === void 0) { defaultTheme = THEMES.light; }
    if (storeApi.get(storeThemeKey) && allowedThemes.includes(storeApi.get(storeThemeKey)))
        return storeApi.get(storeThemeKey);
    return defaultTheme;
};
export var isDark = function () { return getPossibleTheme() === THEMES.dark; };
//# sourceMappingURL=Theme.js.map